const PathwaySkeleton = () => {
    return (
        <div className="flex flex-col gap-4">
            {[1, 2, 3].map(i => (
                <div key={i} className="animate-pulse">
                    <div className="flex items-center gap-4 border border-neutral-300 p-4 rounded-lg">
                        <div className="w-24 h-24 bg-neutral-300 rounded-lg"></div>
                        <div className="flex-1">
                            <div className="h-4 bg-neutral-300 rounded w-3/4 mb-2"></div>
                            <div className="h-3 bg-neutral-300 rounded w-full mb-2"></div>
                            <div className="h-8 bg-neutral-300 rounded w-20"></div>
                        </div>
                        <div className="w-16 h-16 bg-neutral-300 rounded-full"></div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default PathwaySkeleton;
